"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../../core/table"));
var _editableField = _interopRequireDefault(require("../../../core/editable-field"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("th", null, "Membership Type");
class MembershipPermissions extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_togglePermission", (membershipType, tierLevel, currentPermission) => {
      if (!currentPermission) {
        return this.props.addMembershipEntryPermission(membershipType, tierLevel);
      } else {
        return this.props.removeMembershipEntryPermission(membershipType, tierLevel);
      }
    });
  }
  render() {
    const tierLevels = this.props.tierLevels.filter(el => !el.expired);
    const membershipTypes = this.props.membershipTypes.filter(el => !el.expired);
    const entryPermissions = {};
    membershipTypes.map(t => {
      entryPermissions[t.refCode] = {
        refCode: t.refCode,
        description: t.description,
        isExpired: t.isExpired
      };
      tierLevels.map(l => entryPermissions[t.refCode][l.refCode] = false);
    });
    this.props.membershipEntryPermissions.map(ep => !ep.isExpired ? entryPermissions[ep.membershipTypeRef][ep.tierLevelRef] = true : null);
    return /*#__PURE__*/_react.default.createElement(_table.default, {
      size: "sm"
    }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, _ref, tierLevels.map(el => /*#__PURE__*/_react.default.createElement("th", {
      key: el.refCode
    }, el.description)))), /*#__PURE__*/_react.default.createElement("tbody", null, membershipTypes.map(t => /*#__PURE__*/_react.default.createElement("tr", {
      key: t.refCode
    }, /*#__PURE__*/_react.default.createElement("td", null, t.description), tierLevels.map(l => /*#__PURE__*/_react.default.createElement("td", {
      key: l.refCode
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "Checkbox",
      enabled: true,
      name: l.refCode,
      checked: entryPermissions[t.refCode][l.refCode],
      onChange: () => this._togglePermission(t.refCode, l.refCode, entryPermissions[t.refCode][l.refCode])
    })))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref2 = {
  "refCodes(codeType:\"membershiptype\") as membershipTypes": {
    refCode: true,
    description: true,
    isExpired: true
  },
  "refCodes(codeType:\"tierlevel\") as tierLevels": {
    refCode: true,
    description: true,
    isExpired: true
  },
  membershipEntryPermissions: {
    id: true,
    membershipTypeRef: true,
    tierLevelRef: true,
    isExpired: true
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(MembershipPermissions, props => _ref2, (client, props) => ({
  addMembershipEntryPermission(membershipTypeRef, tierLevelRef) {
    return client.update('MembershipEntryPermission.create', {
      membershipTypeRef,
      tierLevelRef
    });
  },
  removeMembershipEntryPermission(membershipTypeRef, tierLevelRef) {
    return client.update('MembershipEntryPermission.delete', {
      membershipTypeRef,
      tierLevelRef
    });
  }
}));